// FIXME: 파일 이동 예정

type Subway = {
  [key: string]: {
    color: string
    text: string
  }
}

export const Subway: Subway = {
  '1호선': {
    color: '#2C338B',
    text: '1',
  },
  '2호선': {
    color: '#39AB43',
    text: '2',
  },
  '3호선': {
    color: '#E86300',
    text: '3',
  },
  '4호선': {
    color: '#3B93D9',
    text: '4',
  },
  '5호선': {
    color: '#832ADC',
    text: '5',
  },
  '6호선': {
    color: '#A8470E',
    text: '6',
  },
  '7호선': {
    color: '#5C6715',
    text: '7',
  },
  '8호선': {
    color: '#DD1963',
    text: '8',
  },
  '9호선': {
    color: '#B1902B',
    text: '9',
  },
  공항철도1호선: {
    color: '#70ACE0',
    text: '공항',
  },
  경의중앙선: {
    color: '#73BD9B',
    text: '경의중앙',
  },
  경춘선: {
    color: '#1CA670',
    text: '경춘',
  },
  수인분당선: {
    color: '#E3A000',
    text: '수인분당',
  },
  신분당선: {
    color: '#991B2B',
    text: '신분당',
  },
  경강선: {
    color: '#3B64EE',
    text: '경강',
  },
  서해선: {
    color: '#7EBE37',
    text: '서해',
  },
  인천1호선: {
    color: '#6A8DCA',
    text: '인천 1',
  },
  인천2호선: {
    color: '#EDA236',
    text: '인천 2',
  },
  에버라인선: {
    color: '#6CBC66',
    text: '에버라인',
  },
  의정부선: {
    color: '#F99322',
    text: '의정부',
  },
  우이신설선: {
    color: '#BABA00',
    text: '우이신설',
  },
  김포골드라인: {
    color: '#88660D',
    text: '김포골드',
  },
  신림선: {
    color: '#4A5B9B',
    text: '신림',
  },
  'GTX-A': {
    color: '#844F7E',
    text: 'GTX-A',
  },
}
